import { FC } from "react";
import { BaseLayout } from "./BaseLayout";

export const SettingsPage: FC = () => {
  return (
    <BaseLayout>
      <div></div>
    </BaseLayout>
  );
};
